"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncGatherPoint = void 0;
/**
 * This is a novel structure to improve code readability when batching needs to occur over multiple partial elements of a structure
 *
 * This is useful when there is a desire to run a function `f(Input) -> Output` as a more efficient
 *   processer function p, of the form `p(Input[]) -> Output[]`. It allows each occurrence of
 *   `f(Input) -> Output` to be altered in place and replaced with `x.add(Input) -> Promise<Output>`
 *   which will resolve when `x.run() -> Promise<void>` is called.
 */
class AsyncGatherPoint {
    constructor(processer) {
        this.data = [];
        this.resolves = [];
        this.rejects = [];
        this.processer = processer;
    }
    /**
     * Add data and return a promise; this promise will resolve once run is called
     *  to run the processer on the batch.
     */
    add(input) {
        let resolve = (_) => { };
        let reject = (_) => { };
        const promise = new Promise((pass, fail) => {
            resolve = pass;
            reject = fail;
        });
        this.data.push(input);
        this.resolves.push(resolve);
        this.rejects.push(reject);
        return promise;
    }
    /**
     * Run process on all added data, causing them to resolve
     */
    async run() {
        const data = this.data;
        this.data = [];
        const resolves = this.resolves;
        this.resolves = [];
        const rejects = this.rejects;
        this.rejects = [];
        return this.processer(data).then((results) => {
            for (let index in resolves) {
                resolves[index](results[index]);
            }
        }, (error) => {
            for (let reject of rejects) {
                reject(error);
            }
        });
    }
}
exports.AsyncGatherPoint = AsyncGatherPoint;
//# sourceMappingURL=AsyncGatherPoint.js.map